import { render, staticRenderFns } from "./MemberPageHeading.vue?vue&type=template&id=bdb4cf88&scoped=true&"
import script from "./MemberPageHeading.vue?vue&type=script&lang=js&"
export * from "./MemberPageHeading.vue?vue&type=script&lang=js&"
import style0 from "./MemberPageHeading.vue?vue&type=style&index=0&id=bdb4cf88&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdb4cf88",
  null
  
)

export default component.exports